import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  TPatchCheckCorrectionRequest,
  TPatchCheckCorrectionResponse,
} from "./checkCorrections.schema";

export const patchCheckCorrection =
  (axios: IAxiosInstance) =>
  async ({ correctionID, ...body }: TPatchCheckCorrectionRequest) => {
    try {
      const response = await axios.noRetry.patch<TPatchCheckCorrectionResponse>(
        `/api/checkCorrections/${encodeURIComponent(correctionID)}`,
        body
      );
      const resData = response.data;

      if (resData.success) {
        return resData.data;
      }
      throw new Error("Something went wrong");
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
